import gql from 'graphql-tag';
import { DocumentNode } from 'graphql';

interface BuildVars {
  (assetId: string): { assetId: string };
}

interface GetPublicAssetQuery {
  query: DocumentNode;
  module: string;
  buildVariables: BuildVars
}

const getPublicAssetQuery = gql`
  query getPublicAsset($assetId: String! ) {
    getPublicAsset(assetId: $assetId) {
      assetId
      organisationId
      filename
      title
      description
      tags
      createdAt
      updatedAt
      altText
      metaData
      assetFiles {
        ORIGINAL {
          assetFileId
          type
          status
          sourceUrl
        },
        THUMBNAIL {
          assetFileId
          type
          status
          sourceUrl
        },
        HD {
          assetFileId
          type
          status
          sourceUrl
        },
        SD {
          assetFileId
          type
          status
          sourceUrl
        },
        STREAM {
          assetFileId
          type
          status
          sourceUrl
          fragments {
            key
            preSignedUrl
          }
        },
        CAPTION {
          assetFileId
          type
          status
          sourceUrl
          metaData
        },
        VTT_CAPTION {
          assetFileId
          type
          status
          sourceUrl
          metaData
        }
      }
    }
  }
`;

const getPublicAsset = (): GetPublicAssetQuery => ({
  query: getPublicAssetQuery,
  module: 'assets',
  buildVariables: (assetId: string) => ({ assetId })
});

export default getPublicAsset;
